export function documentationIssueTitle(documentUrl: string) {
  if (!documentUrl) return '';
  const suffix = ' 文档存在问题，请排查';
  const runes = Array.from(documentUrl);
  const maxUrlLength = 255 - Array.from(suffix).length;
  return (runes.length > maxUrlLength ? `${runes.slice(0, maxUrlLength - 1).join('')}…` : documentUrl) + suffix;
}

export function initDocumentationIssueForm(form: HTMLFormElement) {
  const documentUrl = form.querySelector<HTMLInputElement>('[name="documentation_url"]');
  if (!documentUrl) return;
  const title = form.querySelector<HTMLInputElement>('[name="title"]')!;
  let previousTitle = documentationIssueTitle(documentUrl.value.trim());
  documentUrl.addEventListener('input', () => {
    const nextTitle = documentationIssueTitle(documentUrl.value.trim());
    if (!title.value || title.value === previousTitle) title.value = nextTitle;
    previousTitle = nextTitle;
  });
}
